import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mobile-privacy-policy',
  templateUrl: './mobile-privacy-policy.component.html',
  styleUrls: [

  ]
})
export class MobilePrivacyPolicyComponent {
  darkMode = false;
  constructor(private route: ActivatedRoute) {
    try {
      const mode = this.route.snapshot.queryParams["mode"];
      this.darkMode = mode === "0" || mode === 0;
      const darkClass = this.darkMode ? "dark" : "";
      document.documentElement.className = darkClass;
      document.body.className = darkClass;
    } catch (e) {
    }
  }
}
